<template>
  <div>
    <storage-room-table v-show="activeKey===1" ref="list" :storage-environments="storageEnvironments" :storage-room-types="storageRoomTypes" @add="add" @edit="edit"/>
    <storage-room-detail v-show="activeKey===2" ref="detail" :container-types="containerTypes" :item-types="itemTypes" :order-types="orderTypes" :pack-types="packTypes" :storage-environments="storageEnvironments" :storage-room-types="storageRoomTypes" :storers="storers" :transmission-types="transmissionTypes" @back="back"/>
  </div>
</template>

<script>
import StorageRoomTable from '@/views/basedata/storageroom/StorageRoomTable.vue'
import StorageRoomDetail from '@/views/basedata/storageroom/StorageRoomDetail.vue'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'StorageRoomBaseData',
  components: { StorageRoomTable, StorageRoomDetail },
  data() {
    return {
      activeKey: 1,
      storageRoomTypes: [],
      storageEnvironments: [],
      containerTypes: [],
      packTypes: [],
      transmissionTypes: [],
      storers: [],
      orderTypes: [],
      itemTypes: []
    }
  },
  created() {
    getOptions('containerTypeFactory', { available: true }).then(result => {
      this.containerTypes = result
      return getEnums('StorageRoomType')
    }).then(result => {
      this.storageRoomTypes = result
      return getEnums('StorageEnvironment')
    }).then(result => {
      this.storageEnvironments = result
      return getEnums('PackType')
    }).then(result => {
      this.packTypes = result
      return getEnums('TransmissionType')
    }).then(result => {
      this.transmissionTypes = result
      return getOptions('storerFactory', { available: true })
    }).then(result => {
      this.storers = result
      return getOptions('orderTypeFactory', { available: true, operationType: 2 })
    }).then(result => {
      this.orderTypes = result
      return getDictionaries('ITEM_TYPE')
    }).then(result => {
      this.itemTypes = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(row) {
      this.activeKey = 2
      this.$refs.detail.fetch(row.id)
    }
  }
}
</script>